import * as React from 'react';
import styles from './drag-tag.scss';
import { MdAdd, MdRemove } from 'react-icons/md';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';
interface DragTagComponentProps {
  title: string;
  active: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  added?: boolean;
  subTitle?: string;
}

const DragTagComponent = React.forwardRef((props: DragTagComponentProps, ref: React.LegacyRef<HTMLDivElement>) => {
  const [animationPlayed, setAnimationPlayed] = React.useState(false);
  const { active, title, style, added, onClick, subTitle } = props;
  const activeClassName = active ? styles.dragndropTagActive : '';

  const handleKeypress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      onClick();
    }
  };
  const handleAnimationPlayed = () => {
    setAnimationPlayed(true);
  };

  return (
    // I had to change tag from button to div because existing bug https://github.com/react-dnd/react-dnd/issues/803
    // For us I don't see a big problem in it
    <div
      tabIndex={0}
      className={`${styles.dragndropTag} ${activeClassName} ${added && !animationPlayed ? styles.added : ''} 
        ${subTitle ? styles.withSubTitle : ''}`}
      onClick={onClick}
      onKeyPress={onClick && handleKeypress}
      onAnimationEnd={handleAnimationPlayed}
      style={!!style ? style : {}}
      ref={ref}
    >
      <div className={styles.dragSymbol} />
      <span className={styles.title}>{insertOptionalWordbreaks(title)}</span>
      {active
        ? <MdRemove className={styles.addRemoveIcon} />
        : <MdAdd className={styles.addRemoveIcon} />
      }
      {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
    </div>
  );
});

export const DragTag = React.memo(DragTagComponent);
